export default __webpack_public_path__ + "static/media/cp_geo_pm.b0e22e82.svg";